import { nanoid } from 'nanoid'
import moment from "moment"
import { store } from "../../store/store";
import api from "../../api/httpApi/index";
export async function SetredisCache() {
  if (!sessionStorage.getItem("websocketId")) {
    sessionStorage.setItem("websocketId", nanoid());
  }
  if(!sessionStorage.getItem("websockettime")){
    sessionStorage.setItem("websockettime", moment().format('YYYY-MM-DD HH:mm:ss'));
  }
  if (Math.abs(new Date().getTime() - new Date(sessionStorage.getItem("websockettime")).getTime()) < 1000 * 4 * 60) {
    return;
  }
  let userId = -1;
  let isAdmin = false;
  let displayName = "";
  if (store.getters.getcustomer) {
    userId = store.getters.getcustomer.userId;
    displayName = store.getters.getcustomer.displayName
  }
  else if (store.getters.getAdminUser) {
    userId = store.getters.getAdminUser.userId;
    displayName = store.getters.getAdminUser.displayName
  }
  const params = {
    userId,
    isAdmin,
    displayName,
    MessageType: "userOnline",
    SenderID:  sessionStorage.getItem("websocketId"),
    ReceiverID:  sessionStorage.getItem("websocketId"),
    time: moment().format('YYYY-MM-DD HH:mm:ss')
  };
  const { data: reslut } = await api.common.SetredisCache(params);
  sessionStorage.setItem("websockettime", moment().format('YYYY-MM-DD HH:mm:ss'));
}
export function init(time = 1000 * 60 * 5){
  SetredisCache();
  setInterval(SetredisCache,time)
}


// WEBPACK FOOTER //
// ./src/assets/js/rediscache.js